import 'datatables.net';

export default {
    init() {
        // JavaScript to be fired on the home page
        let table = $("#resource-table").DataTable({
            info: false,
            dom: "t<'novus-table__pagination'p>",
            paging: true,
            pageLength: 5,
            columns: [
                null,
                null,
                null,
                null,
                {
                    "visible": false,
                },
            ],
            language: {
                paginate: {
                    next: "<i class=\"fa fa-caret-right\"></i>",
                    previous: "<i class=\"fa fa-caret-left\"></i>",
                },
            },
        });

        /**
         * Add date filter to form
         */
        $("#daterangepicker").daterangepicker({
            autoUpdateInput: false,
            locale: {
                format: 'DD/MM/YYYY',
                cancelLabel: 'Clear',
            },
        }, function (start, end) {
            let form = document.getElementById("resource-table__filters");

            $("#daterangepicker").val(start.format("DD-MM-YYYY") + " - " + end.format("DD-MM-YYYY"));

            form.elements['latest_date_min'].value = start.format("X");
            form.elements['latest_date_max'].value = end.format("X")
        });

        // Change cancel selection to clear
        // daterangeinput value
        $("#daterangepicker").on("cancel.daterangepicker", function (ev, picker) {
            let form = document.getElementById("resource-table__filters");

            picker.element.get(0).value = "";
            form.elements['latest_date_min'].value = "";
            form.elements['latest_date_max'].value = "";
        });

        /**
         * filter data in datatable when form is submitted
         */
        $("#resource-table__filters").on("submit", function () {
            let text = $("[name='string']", $(this)).val();
            table.column(0).search(text).draw();
        })

        /**
         * Extend datatables with custom filter
         */
        $.fn.dataTableExt.afnFiltering.push(
            function (oSettings, aData) {
                let form = document.getElementById("resource-table__filters");

                let min = form.elements['latest_date_min'].value;
                let max = form.elements['latest_date_max'].value;

                if (min && max) {
                    const postDate = aData[4];

                    if (min == null && max == null) {
                        return true; }
                    if (min == null && postDate <= max) {
                        return true;}
                    if (max == null && postDate >= min) {
                        return true;}
                    if (postDate <= max && postDate >= min) {
                        return true; }
                    return false;
                }

                return true;
            }
        );
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/resources.js